var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flex',{class:{
    'router-link-exact-active': _vm.isCurrentGeoCategory(_vm.geoCategory, _vm.$route.query, _vm.geoType),
  }},[_c('Flex',{class:{ 'cursor-pointer': true }},[_c('router-link',{staticClass:"geo-link",attrs:{"to":_vm.getRoute(_vm.geoCategory, _vm.geoType)}},[_vm._v(" "+_vm._s(_vm.geoCategory.name)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }